import { useState, type MouseEvent } from 'react'

export const useMenu = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const open = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const close = () => {
    setAnchorEl(null)
  }

  return { anchorEl, open, close, isOpen: Boolean(anchorEl) }
}
